import { render } from "./AddPartModal.vue?vue&type=template&id=48d7b016&scoped=true"
import script from "./AddPartModal.vue?vue&type=script&lang=ts"
export * from "./AddPartModal.vue?vue&type=script&lang=ts"

import "./AddPartModal.vue?vue&type=style&index=0&id=48d7b016&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-48d7b016"

export default script